import React from 'react';

const JSON_PHP = () => {
  return (
    <div >
      <h1>JSON_PHP</h1>
      <p>Placeholder component for: "JSON PHP"</p>
    </div>
  );
};

export default JSON_PHP;
